import { useCallback, useState } from "react";

/**
 * Коллбек предназначен для ситуации когда нам необходимо объявить ref,
 * а затем получить ноду после маунта компонента.
 * Выполняет простую функцию - объявляет ref и затем после маунта или
 * анмаунта компонента (элемента) возвращает новое значение.
 * @returns {[node, refCallback]} Возвращает node (null до рендера компонента)
 *                                и RefCallback для прокидывания в ref элемента.
 */
export const useRefCallback = function <T>(): [T | null, React.RefCallback<T>] {
  const [node, setNode] = useState<T | null>(null);

  const refCallback = useCallback((refNode: T) => {
    if (refNode) {
      setNode(refNode);
    }
  }, []);

  return [node, refCallback];
};
